import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id C4A1DAE5-04E0-47EF-84D8-CB81FA58EF87
 * name poll
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/poll.svg
 * tags
 */
export const PollIcon = createSvgIcon(<><path d="M3,22V8H7V22H3M10,22V2H14V22H10M17,22V14H21V22H17Z" /></>, 'PollIcon');
export default PollIcon